import { FetchingActionType, PersistItemsActionType } from 'features/Persist/actionTypes';
import { PersistItemsReducer } from 'features/Persist/reducerTypes';
import { TicketStatusResponse } from 'services/tenantManagementService';
import { TICKET_STATUS_SET, TICKET_STATUS_FETCHING } from './action';

export const ticketStatusReducer = (state = new PersistItemsReducer<TicketStatusResponse>(), action: PersistItemsActionType<TicketStatusResponse> | FetchingActionType): PersistItemsReducer<TicketStatusResponse> => {
	switch (action.type) {
		case TICKET_STATUS_FETCHING:
			const { fetching } = action as FetchingActionType;

			return {
				...state,
				fetching
			}
		case TICKET_STATUS_SET:
			const { items } = action as PersistItemsActionType<TicketStatusResponse>;

			const itemsMap: { [id: number]: TicketStatusResponse } = items.reduce(
                (map: { [id: number]: TicketStatusResponse }, item) => {
					map[item.id] = item;
					return map;
				},
                {}
			);

			return {
				items,
				itemsMap,
				fetching: false,
				isInitialized: true
			}
		default:
			return state;
	}
};
